import { useDispatch, useSelector } from 'react-redux';
import { PLAYER_SEGMENT } from '../constants';
import { canPlay } from '../containers/Player/utils/PlayRules';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { getRegion } from '../utils/Region';
import { checkIfChannelIsBlocked } from './../containers/EPG/actions/channelBlocker/blocker.actions';

export const useOpenPlayer = () => {
  const navigate = useNavigate();
  const infinite = useSelector(state => state?.linealChannel?.data);
  const dispatch = useDispatch();

  const openPlayerWithTransaction = groupId => {
    if (canPlay(groupId, infinite)) {
      dispatch(
        checkIfChannelIsBlocked({
          group_id: groupId,
          onSuccess: () =>
            navigate(`/${getRegion()}${PLAYER_SEGMENT}${groupId}`),
        }),
      );
    } else {
      dispatch(
        checkIfChannelIsBlocked({
          group_id: groupId,
          onSuccess: () => {
            navigate({
              pathname: `/${getRegion()}${PLAYER_SEGMENT}${groupId}`,
              search: `?${createSearchParams({ toBuy: 1 })}`,
            });
          },
        }),
      );
    }
  };

  return { openPlayerWithTransaction };
};
